import Login from "../container/pages/Login";
import Dashboard from "../views/Dashboard";
import { SCREENS_IDS } from "./global-enums";
import Recruiter from "../views/Users/Recruiter/Recruiter";
import Projects from "../views/Users/Project/Projects";
import Candidates from "../views/Users/Candidates/Candidates";
import Companies from "../views/Users/Customers/Companies";
import AssignedRecruiterProjects from "../views/Users/Recruiter/AssignedRecruiterProjects";
import { typeConstants } from "../constants";
import Invoices from "../views/Users/Invoices/Invoices";
import Platform from "../views/Platform/Platform";
import RecruiterReports from "../views/Reports/RecruiterReports";

//Constants to set routes

const PublicRoutes = [
  {
    path: `/`,
    name: "login",
    component: Login,
  },
  {
    path: `/login`,
    name: "login",
    component: Login,
  },
];

const PrivateRoutes = [
  {
    screenId: SCREENS_IDS.DASHBOARD,
    childId: SCREENS_IDS.DASHBOARD,
    UserTypeId: typeConstants.ALLOWED,
    path: `/`,
    name: "Dashboard",
    icon: "ri-dashboard-2-fill",
    sortOrder: "",
    component: Dashboard,
  },
  {
    screenId: SCREENS_IDS.COMPANIES,
    childId: SCREENS_IDS.COMPANIES,
    UserTypeId: typeConstants.ALLOWED,
    path: `/companies`,
    name: "Companies",
    icon: "ri-building-fill",
    sortOrder: "",
    component: Companies,
  },
  {
    screenId: SCREENS_IDS.RECRUITERS,
    childId: SCREENS_IDS.RECRUITERS,
    UserTypeId: typeConstants.ALLOWED,
    path: `/recruiter`,
    name: "Recruiters",
    icon: "ri-group-fill",
    sortOrder: "",
    component: Recruiter,
  },
  {
    screenId: SCREENS_IDS.ALL_PROJECTS,
    childId: SCREENS_IDS.ALL_PROJECTS,
    UserTypeId: typeConstants.ALLOWED,
    path: `/projects`,
    name: "Projects",
    icon: "ri-folder-3-fill",
    sortOrder: "",
    component: Projects,
  },
  {
    screenId: SCREENS_IDS.ALL_CANDIDATES,
    childId: SCREENS_IDS.ALL_CANDIDATES,
    UserTypeId: typeConstants.ALLOWED,
    path: `/candidates`,
    name: "Candidates",
    icon: "ri-shield-user-fill",
    sortOrder: "",
    component: Candidates,
  },
  {
    screenId: SCREENS_IDS.INVOICES,
    childId: SCREENS_IDS.INVOICES,
    UserTypeId: typeConstants.ALLOWED,
    path: `/invoices`,
    name: "Invoices",
    icon: "ri-file-list-3-fill",
    sortOrder: "",
    component: Invoices,
  },
  {
    screenId: SCREENS_IDS.ASSIGNED_PROJECTS,
    childId: SCREENS_IDS.ASSIGNED_PROJECTS,
    UserTypeId: typeConstants.RECRUITER,
    path: `/assigned-projects`,
    name: "Projects",
    icon: "ri-folder-3-fill",
    sortOrder: "",
    component: AssignedRecruiterProjects,
  },
  {
    screenId: SCREENS_IDS.PLATFORM_COMPANIES,
    childId: SCREENS_IDS.PLATFORM_COMPANIES,
    UserTypeId: typeConstants.PLATFORM_ADMIN,
    path: `/platform-companies`,
    name: "Platform Companies",
    icon: "ri-building-fill",
    sortOrder: "",
    component: Platform,
  },
  {
    screenId: SCREENS_IDS.RECRUITERS,
    childId: SCREENS_IDS.RECRUITERS,
    UserTypeId: typeConstants.PLATFORM_ADMIN,
    path: `/recruiter`,
    name: "Recruiters",
    icon: "ri-group-fill",
    sortOrder: "",
    component: Recruiter,
  },
  {
    screenId: SCREENS_IDS.INVOICES,
    childId: SCREENS_IDS.INVOICES,
    UserTypeId: typeConstants.ALLOWED,
    path: `/recruiter-reports`,
    name: "Recruiter Reports",
    icon: "ri-folder-chart-fill",
    sortOrder: "",
    component: RecruiterReports,
  },
];

const RouteConfig = { PublicRoutes, PrivateRoutes };
export default RouteConfig;
